import axios from 'axios';
import BaseAPI from './base/base-api';

class InvoiceCheckHistoryAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'invoicecheckhistory';
}
export default new InvoiceCheckHistoryAPI();

